import React, { useState } from "react";
import { useHttpClientContext } from "../srm-sso-authentication/srm-sso-pass-thru-http-client-context-provider";
import { useEffectAsync } from "../../../../common/hooks/use-effect-async";
import { PageContent } from "../../../page-content/page-content";
import { t } from "i18next";
import { BtmReturnRequestLoader } from "../../btm-returns/btm-request-details/btm-return-request-loader";
import { BtmRequestDetails } from "../../btm-returns/btm-request-details/btm-request-details";
import { BtmReturnRequest } from "../../btm-returns/model/btm-return-request";
import { useParams } from "react-router-dom";
import { GetBtmReturnRequestByDeclarationIdHandler } from "./cqrs/get-btm-return-request-by-declaration-id-handler";

export const SrmBlueReturnDetails = () => {
    const httpClient = useHttpClientContext();
    const [returnRequest, setReturnRequest] = useState<BtmReturnRequest | undefined>(undefined);
    const { id: declarationId } = useParams<{ id: string }>();

    useEffectAsync(async () => {
        if (declarationId) {
            setReturnRequest(await GetBtmReturnRequestByDeclarationIdHandler(httpClient, declarationId));
        }
    }, [declarationId]);

    return <PageContent title={t("components.srmBlueBrandReturns.page.details.title")}
                        description={t("components.srmBlueBrandReturns.page.details.description")}
                        className={"btm-returns-page"}>
        {!returnRequest ?
            <BtmReturnRequestLoader /> :
            <BtmRequestDetails readOnly request={returnRequest} />}
    </PageContent>;
};
